import { render, staticRenderFns } from "./ServiceStatusUpdateArea.vue?vue&type=template&id=01cd5c12&scoped=true&"
import script from "./ServiceStatusUpdateArea.vue?vue&type=script&lang=ts&"
export * from "./ServiceStatusUpdateArea.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceStatusUpdateArea.vue?vue&type=style&index=0&id=01cd5c12&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cd5c12",
  null
  
)

export default component.exports